module.exports = __webpack_public_path__ + "img/339c62c.jpg";